export const anatomyData = [
  { 
    id: 1, 
    name: 'Heart', 
    status: 'Healthy Heart', 
    icon: 'heart',
    statusColor: 'green',
    position: { top: '30%', left: '50%' } 
  },
  { 
    id: 2, 
    name: 'Lungs', 
    status: 'Need Attention', 
    icon: 'lungs',
    statusColor: 'red',
    position: { top: '25%', right: '40%' },
    date: 'Date: 26 Oct 2021'
  },
  { 
    id: 3, 
    name: 'Teeth', 
    status: 'Good Condition', 
    icon: 'teeth',
    statusColor: 'green',
    position: { top: '15%', left: '50%' },
    date: 'Date: 26 Oct 2021'
  },
  { 
    id: 4, 
    name: 'Bone', 
    status: 'Need Attention', 
    icon: 'bone',
    statusColor: 'red',
    position: { bottom: '20%', right: '45%' },
    date: 'Date: 26 Oct 2021'
  }
];

export const activityData = [
  { day: 'Mon', value: 30 },
  { day: 'Tues', value: 70 },
  { day: 'Wed', value: 25 },
  { day: 'Thurs', value: 55 },
  { day: 'Fri', value: 15 },
  { day: 'Sat', value: 45 },
  { day: 'Sun', value: 20 }
];
